import React, { useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import {  MDBRow, MDBCol,MDBInput, MDBBtn,MDBIcon
    , MDBContainer} from 'mdbreact';

    import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardFooter  } from "mdbreact";


    
import Axios from 'axios';
    
import DatePicker from "react-datepicker";
    
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import WarningBox from '../components/WarningBox';
import AccessDenied from '../components/AccessDenied';
import InventoryDetails from './InventoryDetails';
import { MDBProgress } from 'mdbreact';

const Inventory=(props)=> {
    const useMountEffect = (functionName) => useEffect(functionName, [])
  
    const serverURL=props.apiServer;

 const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }


  const [frm, setValues] = useState({
    reporttype:'',
    period:new Date(),
    username:sessionStorage.getItem("msal.uc")
   

  });
  

 
  const [errorMessage,setErrorMessage]=useState("");

  

const notify = message  => {
    toast(message);
}

const [modalWarning,showWarningBox]=useState(false);
  

  
const toggleWarningBox = () => {
  showWarningBox(!modalWarning);

  }


  const getDateValue = dtPickerName =>(actualValue)=>{

    setValues({ ...frm, [dtPickerName]:actualValue});

} 



const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;

      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};
  
  const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });
   
 };

 
 function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
 function formatDate(date) {
  return [
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
    
    date.getFullYear(),
  ].join('/');
}

 function submitHandler (event){
    event.preventDefault();
    event.target.className += " was-validated"; 
    
   GenerateInventory();
   
}


const [rows, setRows] = useState([]);
function loadData() {
    
  Axios.get(props.apiServer + "/processedinventorylist",bearer)
   .then(res => {
     
     setRows(res.data);
      setPreloader("none");
  
   })
 
   .catch(error => {
    
    console.log(error);
   });  
  
 
 
 
 }

 const [startProcessing,setStartProcessing]=useState(false);
 const [progressMax,setProgressMax]=useState(0);
const [progressValue,setProgressValue]=useState(0);
 const [inventoryItems, setInventoryItems] = useState(0);
 function loadinventoryitemsprocessed() {

  if(startProcessing===true)
  {
    return;
  }
  let data =frm;
  
  Axios.post(props.apiServer + "/loadinventoryitemsprocessed",data,bearer)
   .then(res => {
     
    
     setInventoryItems(res.data[0].totalprocessed);
      console.log(frm);
  
   })
 
   .catch(error => {
    
    console.log(error);
   });  
  
 
 
 
 }


const [processed,setProcessed]=useState(false);

const GenerateInventory=()=>
{
  setStartProcessing(true);
  setProgressValue(0);
  setProcessed(false);
  const data =frm;
 

  Axios.post(props.apiServer + "/generateinventory", data,bearer).then(res => {
    
     if (res.data.status === "1") {
    

          setProcessed(true);
          
          setStartProcessing(false);
          setProgressValue(100);
          loadData();
        
     }
     else {
     
      toast.warning(res.data.message, {
          closeButton: false
          
        });
       
       setErrorMessage(res.data.message);
       toggleWarningBox();
       console.log(res.data.message);
       setStartProcessing(false);
       setProgressValue(0);
     }
   }).catch(error => {
       setErrorMessage(error);
       toggleWarningBox();
       setStartProcessing(false);
       setProgressValue(0);
   }); 
 
}

const [currentDate,setCurrentDate]=useState(new Date());
const [isAdmin,checkAdmin]=useState(0);
    
function checkAdminAccess() {
      
  
  Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc") ,bearer)
   .then(res => {
   
      checkAdmin(0);
      checkAdmin(res.data[0].isadmin);
      setPreloader("none");
   })
 
   .catch(error => {
    
    console.log(error);
   });  
  
 
 
 
 }

   
 function gettotalinventoryitems() {
      
  
  Axios.get(props.apiServer + "/gettotalinventoryitems" ,bearer)
   .then(res => {
   
      setProgressMax(0);
      setProgressMax(res.data[0].totalinv);
      setPreloader("none");
   })
 
   .catch(error => {
    
    console.log(error);
   });  
  
 
 
 
 }

 
function printinventory(x,y){

  window.open(props.apiServerHybrid + 'Print/InventoryReport?period=' + x + '&reporttype=' + y,"_blank");


  }

  



 useMountEffect(checkAdminAccess);
 useMountEffect(loadData);
 useMountEffect(gettotalinventoryitems);

 const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const deadline = "December, 31, 2022";

  const getTime = () => {
   
    const time =Date.now();
    
      loadinventoryitemsprocessed();
    

    
    setSeconds(Math.floor((time / 1000) % 60));
  };

  useEffect(() => {

    
    // const interval = setInterval(() => getTime(deadline), 1000);
    const interval = setInterval(() => getTime(), 3000);
    
    return () => clearInterval(interval);
  }, [frm]);



const [currentItem,setCurrentItem]=useState('');
useEffect(() => {


  if(startProcessing===true)
  {
    // for (let i = 0; i < progressMax; i++) {
    //   let rValue=(inventoryItems/progressMax).toFixed(2) * 100.00;
    //   setProgressValue(rValue);
    //   console.log(rValue + " of " + progressMax);
     
    // }
    for (let i = 0; i < 100; i++) {
      let rValue=(inventoryItems/progressMax).toFixed(2) * 100.00;
      if(rValue>=progressMax)
      {
        
        setStartProcessing(false);
        rValue=100;
        setProgressValue(rValue.toFixed(0));
        console.log(rValue + " of " + progressMax);
      }
      else
      {

        setProgressValue(rValue.toFixed(0));

        console.log(rValue + " of " + progressMax);
      }
     
    }
  }
  

  
},[inventoryItems]);




 if( isAdmin==0 ) 
 {
 
   return (
     <React.Fragment>
 
     <AccessDenied />
     </React.Fragment>
    
     
     );
 }
 



/* eslint-disable */

    return (
       <React.Fragment>
   <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
       
     
<MDBCard className="w-100 mt-5">
   
    <MDBCardBody>
     
   <MDBRow>
     <MDBCol md="12">
     <h6  style={{fontFamily:"Montserrat",fontWeight:"400"}} className="display-5 blue-grey-text ml-1 mb-3"> INVENTORY MANAGEMENT</h6>
                   
     </MDBCol>
   </MDBRow>
    <MDBRow hidden >
                       <MDBCol md="12">

                       <MDBInput  
                            hidden
                            value={frm.username} 
                            id="username"  
                            label="username" 
                            >
                                <div className="invalid-feedback">
                                This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                       </MDBCol>

                       
                      
                   </MDBRow>
                
                    
                  
                  


              
                   <MDBRow  hidden>
                       <MDBCol md="12">
                       <MDBInput  
                      
                      
                      id="wholemonth" 
                      label="Whole Month" 
                      type="checkbox"
                      checked={frm.wholemonth}
                      onChange={updateField}
                      
                     >
                      
                          <div className="invalid-feedback">
                          This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                      
                       </MDBCol>

                       
                      
                   </MDBRow>
                   <MDBRow className='mb-3'>

                    <MDBCol  md="3" className="text-left">
                    <label className="grey-text"><small>&nbsp; Period</small></label><br/>
                    <DatePicker
                        
                        placeholderText=""
                        selected={frm.period}
                         onChange={getDateValue("period")}  
                         dateFormat="MM/yyyy"
                         showMonthYearPicker
                         aria-describedby="basic-addon"
                         className="form-control"
                        /> 
                    </MDBCol>

                    <MDBCol md="3" className="text-left"><br/>
                        <MDBBtn type="submit" size="sm" color="primary">
                           Generate Inventory
                        </MDBBtn> 
                        
                        </MDBCol>
                   </MDBRow>
                 
                    {/* <MDBRow className='mb-3'>
                        <MDBCol md="3" className="text-left">
                        <label className="grey-text"><small>&nbsp; From</small></label><br/>
                        <DatePicker
                        
                        
                        selected={frm.datefrom}
                         onChange={getDateValue("datefrom")}  
                            
                        />
                       
                        </MDBCol>

                        <MDBCol md="3" className="text-left">
                        <label className="grey-text"><small>&nbsp;To</small></label><br/>
                        <DatePicker
                        
          
                        selected={frm.dateto}
                         onChange={getDateValue("dateto")}  
                            
                        />
                      
                        </MDBCol>
                        <MDBCol md="3" className="text-left"><br/>
                        <MDBBtn type="submit" size="sm" color="primary">
                           Generate Inventory
                        </MDBBtn> 
                        
                        </MDBCol>
                    </MDBRow> */}

                    <hr/>

                    <MDBRow>
                      <MDBCol MDBCol="12" className='text-center'>

                      <span className='font-weight-bold small'>Processed {inventoryItems} of {progressMax} items.</span>
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                      <MDBCol MDBCol="12">

                      <MDBProgress material height='20px' value={progressValue} max={100} min={0} striped >{progressValue} &nbsp;%</MDBProgress>
                      </MDBCol>
                    </MDBRow>
                    
                    <MDBRow hidden>
                        <MDBCol md="4" className="text-left">
                        <p>{seconds }</p>
                       
                        </MDBCol>

                        <MDBCol md="4" className="text-left">
                        <p>{inventoryItems }</p>
                       
                        </MDBCol>

                    </MDBRow>
                    <React.Fragment>
                   <MDBRow>


                        <MDBCol md="12" >

                        <MaterialTable
                                    title=""
                               

                                  columns={[
                                    
                                    { title: "Inventory Period", field: 'periodtext',
                                      
                                    },

                                    { title: "Generated By", field: 'generatedby',
                                      
                                    },
                                    { title: "Generated On", field: 'transactiondatetime',
                                        
                                      },
                                  ]}



                                  actions={[
                                    {
                                      icon: ()=><MDBIcon icon="print" className="blue-text" />,
                                      tooltip: 'Print summary report of this inventory',
                                      onClick: (event,rowData) => printinventory(rowData.periodtext,'summary')
                                    }
                                    ,{
                                      icon: ()=><MDBIcon far icon="list-alt" className="brown-text" />,
                                      tooltip: 'Print detailed report of this inventory',
                                      onClick: (event,rowData) => printinventory(rowData.periodtext,'detailed')
                                    }
                                  ]}

                                  data={rows
                                  }



                                
                                  options={{ 
                                    search: true,
                                  
                                    pageSize:10,
                                    pageSizeOptions: [ { value: rows.length, label: 'All' },10,25, 50, 100],
                                  }}

                                  detailPanel={[
                                    {
                                    icon: ()=> <MDBIcon icon="chevron-circle-right" className="blue-text" />,
                                    openIcon: ()=><MDBIcon icon="chevron-circle-down"  className="red-text" />,
                                    tooltip:"Detailed Inventory",
                                    render: rowData => {
                                    return (
                  
                  
                  
                                   
                                 
                                      <MDBContainer className="ml-0 mt-0 pt-0" style={{minWidth:"1200px"}}>
                                        
                                        
                                        
                                          <InventoryDetails
                                           deployURL={props.deployURL}
                                           apiServer={props.apiServer}
                                            period={rowData.period}                                           
                                            apiServerHybrid={props.apiServerHybrid}
                                           
                                         
                                          >
                  
                                          </InventoryDetails>
                                         
                                         <MDBCardFooter >
                                                  
                                         </MDBCardFooter>
                                  
                                       </MDBContainer>
                  
                  
                                    )
                                    }
                  
                                    }
                                      
                                    
                                      ]}
                  
                                      />  
                  


                                 

                                  

                        </MDBCol>
                       
                        </MDBRow>

              
                


               
                </React.Fragment>   

                   
                   
                   

                  
                 
                  
                  
                
                   

    </MDBCardBody>
    <MDBCardFooter>
    
                               
    </MDBCardFooter>
   
  </MDBCard>

  <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />


  </form>

  

                <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>

                </React.Fragment>    
    )
}

export default Inventory
